module.exports = __webpack_public_path__ + "static/img/13.fcc3314.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/eng/13.png
// module id = Yc/k
// module chunks = 0